import { SearchFacetInput, SearchIndexField } from '__generated__/graphql'
import { useRosterSearch } from './useRosterSearch'

interface FilterValue {
    category: SearchFacetInput['category']
    value: SearchFacetInput['value']
}

export function useRosterSearchFilter(facet: SearchIndexField) {
    const { tableState, setTableState } = useRosterSearch()

    const currentFilter = tableState.filters.find((f) => f.facet === facet)

    const setValue = (newValue: FilterValue | null) => {
        const otherFilters = tableState.filters.filter((f) => f.facet !== facet)

        if (newValue === null) {
            setTableState({ filters: otherFilters })
        } else {
            setTableState({
                filters: [...otherFilters, { facet, ...newValue }],
            })
        }
    }

    return { value: currentFilter, setValue }
}
